export default function Icon({
  name,
  size = 16,
  className = '',
  title,
}) {
  return (
    <i
      className={`uil uil-${name} ${className}`}
      style={{ fontSize: size }}
      title={title}
      aria-hidden="true"
    />
  );
}
